import styled from "styled-components";
import { colors } from "../../helpers/functions";

export const FooterStyled = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    background-color: #000000;
    width: 100%;
    height: 85vw;
    box-sizing: border-box;
    padding: 10vw;
    p{
        padding: 0;
        margin: 0;
    }
    .logo_footer{
        width: 60vw;
        img{
            float: left;
            width: 100%;
        }
    }
    .contacto{
        text-align: center;
        color: #FFFFFF;
        .email{
            font-weight: 600;
            /* margin-top: 2.5vw; */
            font-size: 4vw;
            line-height: 5vw;
            font-weight: 500;
        }
    }
    .social{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 28vw;
        .bt_instagram{
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 8vw;
            line-height: 8vw;
            //color: rgb(${colors.marron_tierra});
            color: #FFFFFF;
            //border: 3px solid rgb(${colors.marron_tierra});
            border: 3px solid #FFFFFF;
            width: 12vw;
            height: 12vw;
            border-radius: 10px;
        }
        .bt_facebook{
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 7vw;
            line-height: 7vw;
            //color: rgb(${colors.marron_tierra});
            color: #FFFFFF;
            //border: 3px solid rgb(${colors.marron_tierra});
            border: 3px solid #FFFFFF;
            width: 12vw;
            height: 12vw;
            border-radius: 10px;
        }
    }
    .direccion{
        width: 100%;
        text-align: center;
        font-size: 4vw;
        line-height: 4vw;
        font-weight: 600;
    }

    .back_marron_tierra{
        background-color: rgba(${colors.marron_tierra}, 1);
    }
    .back_verde_brocoli{
        background-color: rgba(${colors.verde_brocoli}, 1);
    }
    .back_verde_acelga{
        background-color: rgba(${colors.verde_acelga}, 1);
    }
    .back_azul_agua{
        background-color: rgba(${colors.azul_agua}, 1);
    }
    .back_naranja_pimiento{
        background-color: rgba(${colors.naranja_pimiento}, 1);
    }
    .back_amarillo_banana{
        background-color: rgba(${colors.amarillo_banana}, 1);
    }
    .back_blanco_huevo{
        background-color: rgba(${colors.blanco_huevo}, 1);
    }

    .text_marron_tierra{
        color: rgba(${colors.marron_tierra}, 1);
    }
    .text_verde_brocoli{
        color: rgba(${colors.verde_brocoli}, 1);
    }
    .text_verde_acelga{
        color: rgba(${colors.verde_acelga}, 1);
    }
    .text_azul_agua{
        color: rgba(${colors.azul_agua}, 1);
    }
    .text_naranja_pimiento{
        color: rgba(${colors.naranja_pimiento}, 1);
    }
    .text_amarillo_banana{
        color: rgba(${colors.amarillo_banana}, 1);
    }
    .text_blanco_huevo{
        color: rgba(${colors.blanco_huevo}, 1);
    }

    .wp_contact{
        font-size: 4vw;
        line-height: 4vw;
        padding: 1.3vw 2.2vw;
        margin-top: 3vw;
        .wp_icon{
            font-size: 5vw;
            line-height: 5vw;
        }
    }

    .wp_numero{
        color: #FFFFFF;
    }

    @media (max-width: 480px) {
        /* Mobile styles */
    }

    @media (min-width: 481px) and (max-width: 768px) {
        /* Tablet styles */
    }

    @media (min-width: 769px) and (max-width: 1024px) {
        /* Desktop small styles */
    }

    @media (min-width: 1025px) and (max-width: 1200px) {
        /* Desktop medium styles */
    }

    @media (min-width: 1201px) {
        height: 500px;
        padding: 40px;
        p{
            padding: 0;
            margin: 0;
        }
        .logo_footer{
            width: 500px;
        }
        .contacto{
            .email{
                font-weight: 600;
                font-size: 20px;
                line-height: 28px;
            }
        }
        .social{
            width: 200px;
            .bt_instagram{
                font-size: 45px;
                line-height: 45px;
                width: 90px;
                height: 90px;
                border-radius: 10px;
            }
            .bt_facebook{
                font-size: 45px;
                line-height: 45px;
                width: 90px;
                height: 90px;
                border-radius: 10px;
            }
        }
        .direccion{
            font-size: 20px;
            line-height: 20px;
        }
    }
`